export default __webpack_public_path__ + "static/media/DFYC2026Kit_page.4c11fd62.jpg";